import "./CounselingDirection.module.css";
import Header from "@/reusable_sections/Header";
import CounselingDirectionIntro from "./sections/CounselingDirectionIntro";
import ThreeDirections from "./sections/ThreeDirections";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function CounselingDirectionPage() {
  return <div>
      <Header />
      <CounselingDirectionIntro />
      <ThreeDirections />
      <CallToAction />
      <Footer />
    </div>;
}